import * as tslib_1 from "tslib";
import { injectGlobal, keyframes } from 'styled-components';
var rippleEnter = keyframes(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  0% {\n    transform: scale(0);\n    opacity: 0.1;\n  }\n\n  100% {\n    transform: scale(1);\n    opacity: 0.3,\n  }\n"], ["\n  0% {\n    transform: scale(0);\n    opacity: 0.1;\n  }\n\n  100% {\n    transform: scale(1);\n    opacity: 0.3,\n  }\n"])));
var ripplePulsate = keyframes(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  0% {\n      transform: scale(1);\n  }\n\n  50% {\n      transform: scale(0.92);\n  }\n\n  100% {\n    transform: scale(1);\n  }\n"], ["\n  0% {\n      transform: scale(1);\n  }\n\n  50% {\n      transform: scale(0.92);\n  }\n\n  100% {\n    transform: scale(1);\n  }\n"])));
var rippleExit = keyframes(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  0% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0%;\n  }\n"], ["\n  0% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0%;\n  }\n"])));
// tslint:disable-next-line:no-unused-expression
injectGlobal(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  .sinoui-ripple-element {\n    position: relative;\n  }\n  .sinoui-ripple-layout {\n    position: absolute;\n    pointer-events: none;\n    overflow: hidden;\n    z-index: 0;\n  }\n\n  .sinoui-button-ripple-layout {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n  }\n\n  .sinoui-ripple {\n    position: absolute;\n    display: block;\n    top: 0;\n    left: 0;\n    width: 50px;\n    height: 50px;\n    opacity: 0.3;\n    transform: scale(1);\n    animation: ", " 450ms cubic-bezier(0.4, 0, 0.2, 1);\n  }\n\n  .sinoui-ripple::after {\n    content: ' ';\n    width: 100%;\n    height: 100%;\n    opacity: 1;\n    display: block;\n    border-radius: 50%;\n    background-color: currentColor;\n  }\n\n  .sinoui-ripple-pulsate {\n    animation-duration: 200ms;\n  }\n\n  .sinoui-ripple-pulsate::after {\n    position: absolute;\n    top: 0;\n    left: 0;\n    animation: ", " 2500ms cubic-bezier(0.4, 0, 0.2, 1) 200ms infinite;\n  }\n\n  .sinoui-ripple-exit::after {\n    opacity: 0;\n    animation: ", " 400ms cubic-bezier(0.4, 0, 0.2, 1);\n  }\n"], ["\n  .sinoui-ripple-element {\n    position: relative;\n  }\n  .sinoui-ripple-layout {\n    position: absolute;\n    pointer-events: none;\n    overflow: hidden;\n    z-index: 0;\n  }\n\n  .sinoui-button-ripple-layout {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n  }\n\n  .sinoui-ripple {\n    position: absolute;\n    display: block;\n    top: 0;\n    left: 0;\n    width: 50px;\n    height: 50px;\n    opacity: 0.3;\n    transform: scale(1);\n    animation: ", " 450ms cubic-bezier(0.4, 0, 0.2, 1);\n  }\n\n  .sinoui-ripple::after {\n    content: ' ';\n    width: 100%;\n    height: 100%;\n    opacity: 1;\n    display: block;\n    border-radius: 50%;\n    background-color: currentColor;\n  }\n\n  .sinoui-ripple-pulsate {\n    animation-duration: 200ms;\n  }\n\n  .sinoui-ripple-pulsate::after {\n    position: absolute;\n    top: 0;\n    left: 0;\n    animation: ", " 2500ms cubic-bezier(0.4, 0, 0.2, 1) 200ms infinite;\n  }\n\n  .sinoui-ripple-exit::after {\n    opacity: 0;\n    animation: ", " 400ms cubic-bezier(0.4, 0, 0.2, 1);\n  }\n"])), rippleEnter, ripplePulsate, rippleExit);
var RippleRender = /** @class */ (function () {
    function RippleRender(element, rippleConfig) {
        this.element = element;
        this.rippleConfig = rippleConfig;
        this.focusRipple = this.focusRipple.bind(this);
        this.blurRipple = this.blurRipple.bind(this);
        this.addRipple = this.addRipple.bind(this);
        this.removeRipple = this.removeRipple.bind(this);
        this.rippleInstances = [];
        this.timeouts = [];
    }
    /**
     * 显示focus状态下的ripple效果，为pulsate效果。
     *
     * @returns
     * @memberof RippleRender
     */
    RippleRender.prototype.focusRipple = function () {
        this.addRippleLayout();
        var ripplePos = this.getRipplePos(true);
        var rippleSize = this.getCenterRippleSize();
        var ripple = this.createRippleInstance(ripplePos, rippleSize);
        ripple.classList.add('sinoui-ripple-pulsate');
        this.rippleLayout.appendChild(ripple);
        this.focusRippleInstance = ripple;
        return Promise.resolve();
    };
    RippleRender.prototype.blurRipple = function () {
        if (this.focusRippleInstance) {
            this.rippleLayout.removeChild(this.focusRippleInstance);
        }
        return Promise.resolve();
    };
    /**
     * 添加ripple
     *
     * @param {(MouseEvent | TouchEvent)} [event]
     */
    RippleRender.prototype.addRipple = function (event) {
        this.addRippleLayout();
        var ripplePos = this.getRipplePos(this.rippleConfig.center, event);
        var rippleSize = this.getRippleSize(ripplePos);
        var ripple = this.createRippleInstance(ripplePos, rippleSize);
        this.rippleLayout.appendChild(ripple);
        this.rippleInstances.push(ripple);
        return Promise.resolve();
    };
    /**
     * 删除ripple
     */
    RippleRender.prototype.removeRipple = function () {
        var _this = this;
        var ripple = this.rippleInstances.shift();
        if (ripple) {
            ripple.classList.add('sinoui-ripple-exit');
            var timeout_1 = setTimeout(function () {
                _this.clearContainerRect();
                _this.rippleLayout.removeChild(ripple);
                _this.timeouts.splice(_this.timeouts.indexOf(timeout_1), 1);
            }, 550);
            this.timeouts.push(timeout_1);
        }
        return Promise.resolve();
    };
    RippleRender.prototype.clean = function () {
        clearTimeout(this.containerRectTimeout);
        this.timeouts.forEach(function (timeout) { return clearTimeout(timeout); });
    };
    RippleRender.prototype.clearContainerRect = function () {
        var _this = this;
        clearTimeout(this.containerRectTimeout);
        var timeout = setTimeout(function () {
            if (_this.rippleInstances.length === 0) {
                _this.containerRect = null;
            }
        }, 450);
        this.containerRectTimeout = timeout;
    };
    RippleRender.prototype.getContainerRect = function () {
        if (!this.containerRect) {
            this.containerRect = this.rippleLayout.getBoundingClientRect();
        }
        return this.containerRect;
    };
    RippleRender.prototype.createRippleInstance = function (ripplePos, rippleSize) {
        var ripple = document.createElement('span');
        if (!this.rippleConfig.fixSize) {
            ripple.style.width = rippleSize + "px";
            ripple.style.height = rippleSize + "px";
        }
        if (!this.rippleConfig.center) {
            ripple.style.left = -(rippleSize / 2) + ripplePos.x + "px";
            ripple.style.top = -(rippleSize / 2) + ripplePos.y + "px";
        }
        ripple.classList.add('sinoui-ripple');
        if (this.rippleConfig.rippleClassName) {
            ripple.classList.add(this.rippleConfig.rippleClassName);
        }
        return ripple;
    };
    RippleRender.prototype.getRippleSize = function (pos) {
        var sizeX = Math.max(Math.abs(this.getContainerRect().width - pos.x), pos.x) * 2 + 2;
        var sizeY = Math.max(Math.abs(this.getContainerRect().height - pos.y), pos.y) * 2 + 2;
        var rippleSize = Math.sqrt(Math.pow(sizeX, 2) + Math.pow(sizeY, 2));
        return rippleSize;
    };
    /**
     * 获取在元素中心显示的ripple的尺寸
     *
     * @private
     * @memberof RippleRender
     */
    RippleRender.prototype.getCenterRippleSize = function () {
        var rect = this.getContainerRect();
        var rippleSize = Math.sqrt((2 * Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) / 3);
        return rippleSize;
    };
    /**
     * 获取ripple元素的尺寸
     *
     * @private
     * @param {boolean} center
     * @param {(MouseEvent | TouchEvent)} [event]
     * @returns
     * @memberof RippleRender
     */
    RippleRender.prototype.getRipplePos = function (center, event) {
        var rect = this.getContainerRect();
        if (center || !event) {
            return {
                x: rect.width / 2,
                y: rect.height / 2,
            };
        }
        var clientX = event.clientX ||
            (event.touches
                ? event.touches[0].clientX
                : 0);
        var clientY = event.clientY ||
            (event.touches
                ? event.touches[0].clientY
                : 0);
        if (clientX === 0 && clientY === 0) {
            return {
                x: rect.width / 2,
                y: rect.height / 2,
            };
        }
        return {
            x: Math.round(clientX - rect.left),
            y: Math.round(clientY - rect.top),
        };
    };
    RippleRender.prototype.addRippleLayout = function () {
        if (!this.rippleLayout) {
            this.rippleLayout = document.createElement('span');
            // 修复IE不支持多参数的add引起的bug：[can i use - classList](https://caniuse.com/#feat=classlist)
            this.rippleLayout.classList.add('sinoui-ripple-layout');
            this.rippleLayout.classList.add(this.rippleConfig.rippleLayoutClassName ||
                'sinoui-button-ripple-layout');
            if (this.rippleConfig.color) {
                this.rippleLayout.style.color = this.rippleConfig.color;
            }
            this.element.appendChild(this.rippleLayout);
        }
    };
    return RippleRender;
}());
export default RippleRender;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=RippleRender.js.map